import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WidokState } from './lewy-panel-widok.reducer';
import { WIDOKI_ID } from './lewy-panel-widok.const';

export const selectModulMapowyState = createFeatureSelector<any>('modulMapowy');

export const selectLewyPanelWidokState = createSelector(
  selectModulMapowyState,
  (modulMapowyState) => modulMapowyState?.widoki
);

export const selectAktualnyWidokId = createSelector(
  selectLewyPanelWidokState,
  (state: WidokState) => state?.top
);

export const selectCzyWidokToNarzedzia = createSelector(
  selectAktualnyWidokId,
  (widokId) => widokId === WIDOKI_ID.NARZEDZIA
);
